import React from 'react';
import { Play } from 'lucide-react';

export default function PlayButtonOverlay(): React.ReactElement {
  return (
    <div className="play-button-overlay">
      <Play className="play-button" size={48} fill="white" strokeWidth={0} />
    </div>
  );
}
